import React from "react";

import { faArrowRight } from "@fortawesome/sharp-regular-svg-icons/faArrowRight";
import clsx from "clsx";

import { IconFontAwesome } from "~components/IconFontAwesome";
import { Link } from "~components/Link";
import { StoryblokRichText } from "~components/StoryblokRichText";

import { mobileCallout } from "~sections/Nav/mobile/styles.css";

import { type CallOut as CallOutProps } from "../Nav.types";
import { navigationMenuCallout } from "../desktop/styles.css";

export function Callout({ description, link, darkMode }: CallOutProps) {
  return (
    <Link
      link={link}
      className={clsx(navigationMenuCallout({ darkMode }), mobileCallout)}
    >
      <StoryblokRichText text={description} />
      <IconFontAwesome icon={faArrowRight} padding="spacing1" />
    </Link>
  );
}
